import { MutationTree } from 'vuex'
import { emptyUser, loadingUser } from './constants'
import State, { User } from './types'

export const mutations: MutationTree<State> = {
  currentUserLoggedOut(state: State) {
    state.error = false
    state.currentUser = emptyUser
  },
  currentUserLoading(state: State) {
    state.error = false
    state.currentUser = loadingUser
    state.loginCodeUser = emptyUser
    state.acceptanceUser = emptyUser
  },
  currentUserLoaded(state: State, { user }: { user: User }) {
    state.error = false
    state.currentUser = user
  },
  acceptanceUserLoaded(state: State, { user }: { user: User }) {
    state.error = false
    state.acceptanceUser = user
    state.loginCodeUser = emptyUser
  },
  acceptanceSuccess(state: State) {
    state.error = false
    state.currentUser = state.acceptanceUser
    state.acceptanceUser = emptyUser
  },
  acceptanceDone(state: State) {
    state.error = false
    state.acceptanceUser = emptyUser
  },
  loginCodeUserLoaded(state: State, { user }: { user: User }) {
    state.error = false
    state.loginCodeUser = user
  },
  currentUserError(state: State) {
    state.error = true
    state.currentUser = emptyUser
  },
  userPasswordExpired(state: State, userName : string) {
    state.error = true
    state.passwordExpired = true
    state.resetUsername = userName
  },
  userPasswordReset(state: State) {
    state.error = false
    state.passwordExpired = false
    state.resetUsername = ''
  },
  // setActiveUser(state, { site }: { site: User | None }) {
  //   state.activeSite = _.assign({}, active, _.pick(site, ['UserIdId', 'Username']))
  // },
}
